module.exports = __webpack_public_path__ + "static/media/award.9037ff10.jpg";